import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Flow Control Loop v1 Configuration Validator
 * Loop nodes iterate over an array with an optional limit
 * Supports liquid variables for dynamic iteration
 */
export const Flow_Control_Loop_1_ConfigValidator = z.object({
    iterable: requiredString('Iterable is required'),
    limit: z.int('Limit must be a whole number').min(1, 'Limit must be at least 1').optional()
});
//# sourceMappingURL=flow-control-loop-1.js.map